var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-roles-form',{ref:"form",staticClass:"pt-roles-form__withData",attrs:{"isEdit":_vm.isEdit,"id":_vm.id,"permissionsList":_vm.permissionsList,"rolesList":_vm.rolesList,"rolesDetail":_vm.rolesDetail,"submitLoading":_vm.submitLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }